import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "user-form" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BButton = _resolveComponent("BButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BButtonGroup = _resolveComponent("BButtonGroup")!
  const _component_BButtonToolbar = _resolveComponent("BButtonToolbar")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_BFormGroup = _resolveComponent("BFormGroup")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_FormList = _resolveComponent("FormList")!
  const _component_PermissionsPanel = _resolveComponent("PermissionsPanel")!
  const _component_ItemSelectModal = _resolveComponent("ItemSelectModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(this.entity.id ? "Edit" : "Create") + " " + _toDisplayString(_ctx.$t("systemUserForm.user")) + " " + _toDisplayString(_ctx.entity.name), 1),
    _createVNode(_component_BButtonToolbar, { class: "mb-2 pt-2 pb-2 border-light border-top border-bottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_BButtonGroup, null, {
          default: _withCtx(() => [
            _createVNode(_component_BButton, {
              size: "sm",
              variant: "outline-primary",
              onClick: _ctx.onClose,
              class: "custom-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("systemUserForm.close")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_BButton, {
              disabled: !_ctx.isDirty,
              class: "ml-2",
              size: "sm",
              variant: "primary",
              onClick: _ctx.onSave,
              style: {"background-color":"#0054a6","color":"white"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "save" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("systemUserForm.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BForm, { ref: "form" }, {
          default: _withCtx(() => [
            _createVNode(_component_BFormGroup, {
              id: "input-group-1",
              description: "Email should be unique.",
              label: "Email:",
              "label-for": "input-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BFormInput, {
                  id: "input-1",
                  modelValue: _ctx.entity.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.email) = $event)),
                  placeholder: "Enter Email",
                  required: "",
                  type: "email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_BFormGroup, {
              id: "input-group-2",
              label: "Name:",
              "label-for": "input-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BFormInput, {
                  id: "input-2",
                  modelValue: _ctx.entity.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.name) = $event)),
                  placeholder: "Enter Name",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_BFormGroup, {
              id: "input-group-3",
              label: "User Name:",
              "label-for": "input-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BFormInput, {
                  id: "input-3",
                  modelValue: _ctx.entity.userName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.userName) = $event)),
                  placeholder: "Enter User Name",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.isCreateMode)
              ? (_openBlock(), _createBlock(_component_BFormGroup, {
                  key: 0,
                  id: "input-group-password",
                  label: "Password:",
                  "label-for": "input-password"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_BFormInput, {
                        id: "input-password",
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                        required: "",
                        type: _ctx.showPassword ? 'text' : 'password',
                        onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passwordFocused = true)),
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.passwordFocused = false))
                      }, null, 8, ["modelValue", "type"]),
                      (_ctx.passwordFocused)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: _ctx.showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye',
                            class: "eye-icon",
                            onMousedown: _withModifiers(_ctx.togglePassword, ["prevent"])
                          }, null, 8, ["icon", "onMousedown"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FormList, {
          data: _ctx.roles,
          disabled: _ctx.isCreateMode,
          onRemoved: _ctx.onRemoveRole,
          onSelected: _ctx.onSelectRole
        }, {
          default: _withCtx(() => [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t("systemUserForm.roles")), 1)
          ]),
          _: 1
        }, 8, ["data", "disabled", "onRemoved", "onSelected"]),
        _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
        (_ctx.formReady)
          ? (_openBlock(), _createBlock(_component_PermissionsPanel, {
              key: 0,
              disabled: _ctx.isCreateMode || !_ctx.canModifyPermissions,
              "provider-name": "U",
              "provider-key": _ctx.id
            }, null, 8, ["disabled", "provider-key"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ItemSelectModal, {
      ref: "roleSelectModal",
      "entity-type-name": 'Role',
      items: _ctx.availableRoles,
      "window-id": 'roles',
      "value-field": 'name',
      onItemSelected: _ctx.onRoleSelected
    }, null, 8, ["items", "onItemSelected"])
  ]))
}